
import React from 'react';
import AdBanner from './AdBanner';

interface FooterProps {
  showAds: boolean;
  onPrivacyPolicyClick: () => void;
  onAboutUsClick: () => void;
  onContactUsClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ showAds, onPrivacyPolicyClick, onAboutUsClick, onContactUsClick }) => {
  return (
    <footer className="bg-navy-blue text-center py-6">
      <div className="container mx-auto px-4">
        <a 
          href="https://mempool.space" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-btc-orange hover:text-orange-400 font-semibold transition-colors duration-300 text-lg"
        >
          Explore with Mempool.space
        </a>

        {showAds && (
          <div className="my-6 text-center">
            <div className="bg-dark-blue rounded-lg p-2 min-h-[60px] max-w-lg mx-auto">
              <AdBanner
                data-ad-client="ca-pub-5297401074014823"
                data-ad-slot="ZZZZZZZZZZ"
                data-ad-format="auto"
                data-full-width-responsive="true"
              />
            </div>
          </div>
        )}

        <div className="text-sm text-light-blue mt-4 flex justify-center items-center flex-wrap">
          <span>© {new Date().getFullYear()} BTC Gain & Loss Calculator. All rights reserved.</span>
          <span className="mx-2 hidden sm:inline">|</span>
          <button
            onClick={onAboutUsClick}
            className="hover:underline text-btc-orange transition-colors duration-300 mx-2"
          >
            About Us
          </button>
          <span className="mx-2">|</span>
           <button
            onClick={onContactUsClick}
            className="hover:underline text-btc-orange transition-colors duration-300 mx-2"
          >
            Contact Us
          </button>
          <span className="mx-2">|</span>
          <button
            onClick={onPrivacyPolicyClick}
            className="hover:underline text-btc-orange transition-colors duration-300 mx-2"
          >
            Privacy Policy
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
